var _g, _rect, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRow14(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2335_35634)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    rx: 8,
    fill: "#161616"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    fill: "#161616"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_2335_35634)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 30V16H44V44H16",
    fill: "#007ACC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.1387 30.0488V31.1898H25.7787V41.5498H28.3617V31.1898H32.0017V30.0698C32.0017 29.4398 32.0017 28.9288 31.9737 28.9148C31.9737 28.8938 29.7547 28.8868 27.0597 28.8868L22.1597 28.9078V30.0558L22.1387 30.0488ZM38.4977 28.8798C39.2117 29.0478 39.7577 29.3698 40.2477 29.8808C40.5067 30.1608 40.8917 30.6508 40.9197 30.7768C40.9197 30.8188 39.7087 31.6378 38.9737 32.0928C38.9457 32.1138 38.8337 31.9948 38.7217 31.8128C38.3577 31.2948 37.9867 31.0708 37.4057 31.0288C36.5657 30.9728 36.0057 31.4138 36.0057 32.1488C36.0057 32.3728 36.0477 32.4988 36.1317 32.6808C36.3207 33.0658 36.6707 33.2968 37.7557 33.7728C39.7577 34.6338 40.6257 35.2008 41.1507 36.0128C41.7457 36.9228 41.8787 38.3508 41.4797 39.4218C41.0317 40.5908 39.9397 41.3818 38.3787 41.6408C37.8887 41.7248 36.7687 41.7108 36.2437 41.6198C35.1237 41.4098 34.0527 40.8498 33.3947 40.1288C33.1357 39.8488 32.6387 39.0998 32.6667 39.0508L32.9327 38.8828L33.9827 38.2738L34.7737 37.8118L34.9557 38.0568C35.1867 38.4208 35.7047 38.9108 36.0057 39.0788C36.9157 39.5478 38.1337 39.4848 38.7357 38.9388C38.9947 38.7008 39.1067 38.4488 39.1067 38.0988C39.1067 37.7768 39.0577 37.6298 38.8967 37.3848C38.6727 37.0768 38.2247 36.8248 36.9647 36.2648C35.5157 35.6488 34.8997 35.2568 34.3257 34.6548C33.9967 34.2908 33.6957 33.7238 33.5557 33.2548C33.4507 32.8488 33.4157 31.8548 33.5137 31.4558C33.8147 30.0558 34.8717 29.0758 36.3837 28.7958C36.8737 28.6978 38.0287 28.7398 38.5117 28.8658L38.4977 28.8798Z",
    fill: "white"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 59,
    height: 59,
    rx: 7.5,
    stroke: "white",
    strokeOpacity: 0.2
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2335_35634"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    rx: 8,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_2335_35634"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white",
    transform: "translate(16 16)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRow14);
export default __webpack_public_path__ + "static/media/row-1-4.45523c1e860ecf7f8b6190ba75c2ee88.svg";
export { ForwardRef as ReactComponent };